import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import { isTaskCompleted } from "../helpers";
import { OrganizationGamificationTask } from "../schema";
import CardHeader from "./CardHeader";
import CreateNicheTemplateCard from "./CreateNicheTemplateCard";
import WeeklyConsistencyChallenge from "./WeeklyConsistencyChallenge";

interface Props {
  numOfCardsToRender: number | null;
}

const ExperiencePro = ({ numOfCardsToRender }: Props) => {
  const { gamificationProfile } = useContext(OrganizationUserContext);

  return (
    <>
      <CardHeader
        title="Pitching Challenges"
        description="Unlock Bento Site Credit!"
        icon="fa-solid fa-bullseye"
      />
      {numOfCardsToRender && numOfCardsToRender > 0 ? (
        <CreateNicheTemplateCard
          title={"Create Niche-Specific Template"}
          description="Customize your pitch for a specific niche (e.g., beauty, fitness, tech)"
          completed={isTaskCompleted(
            gamificationProfile,
            OrganizationGamificationTask.niche_templates,
            1,
          )}
          infoBox={
            <>
              {" "}
              <strong>Pro tip:</strong> Different niches respond to different
              pitching styles. A beauty brand cares about aesthetics and
              engagement, while a tech brand wants to see expertise and audience
              demographics.
            </>
          }
        />
      ) : null}
      <WeeklyConsistencyChallenge
        completed={isTaskCompleted(
          gamificationProfile,
          OrganizationGamificationTask.email_streak,
          1,
        )}
      />
    </>
  );
};

export default ExperiencePro;
